import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["panel", "overlay"]
  static values = { open: { type: Boolean, default: false } }

  toggle() {
    this.openValue = !this.openValue
  }

  close() {
    if (!this.openValue) return
    this.openValue = false
  }

  openValueChanged() {
    this.panelTarget.classList.toggle("translate-x-full", !this.openValue)
    this.overlayTarget.classList.toggle("opacity-0", !this.openValue)
    this.overlayTarget.classList.toggle("pointer-events-none", !this.openValue)
    document.body.classList.toggle("overflow-hidden", this.openValue)
  }
}
